module.exports = __webpack_public_path__ + "media/dashboard/assets/images/new-chat-890345d59b085f302c12b09149e659b0.png";